(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spf-flip-box"] && !Shopify.designMode) return;
  try {
    
                      document.addEventListener('DOMContentLoaded', function() {
                          // Select all flip box fronts
                          const flipBoxFronts = document.querySelectorAll('.flip-box-front');
                        
                          // Add click event listener to each flip box front
                          flipBoxFronts.forEach(flipBoxFront => {
                            flipBoxFront.addEventListener('click', function() {
                              // Find the closest parent `.flip-box` and then its child `.flip-box-inner`
                              const flipBoxInner = flipBoxFront.closest('.gallery-block__image').querySelector('.flip-box-inner');
                              
                              // Toggle the 'flipped' class on the inner container
                              flipBoxInner.classList.add('flipped');
                            });
                          });
                        });            
                        
  } catch(e) { console.error(e); }
})();
})();
